import { VeryGoodIcon, GoodIcon, OkIcon, BadIcon, VeryBadIcon } from './styles';

export const moods = {
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.1.VERY.GOOD': <VeryGoodIcon />,
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.2.GOOD': <GoodIcon />,
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.3.OK': <OkIcon />,
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.4.BAD': <BadIcon />,
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.5.VERY.BAD': <VeryBadIcon />,
};

export const moodValues = {
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.1.VERY.GOOD':
    'CAREMATRIXCPTC.MTMOOD.1VERYGOOD',
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.2.GOOD': 'CAREMATRIXCPTC.MTMOOD.2GOOD',
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.3.OK': 'CAREMATRIXCPTC.MTMOOD.3OK',
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.4.BAD': 'CAREMATRIXCPTC.MTMOOD.4BAD',
  'EXPLORE.MOOD.TRACKER.MOOD.ANSWER.5.VERY.BAD':
    'CAREMATRIXCPTC.MTMOOD.5VERYBAD',
};

export const feelingsValues = {
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.HAPPINESS':
    'CAREMATRIXCPTC.MTEMOTIONS.HAPPINESS',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.LOVE': 'CAREMATRIXCPTC.MTEMOTIONS.LOVE',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.ANXIETY':
    'CAREMATRIXCPTC.MTEMOTIONS.ANXIETY',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.FEAR': 'CAREMATRIXCPTC.MTEMOTIONS.FEAR',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.FATIGUE':
    'CAREMATRIXCPTC.MTEMOTIONS.FATIGUE',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.CONFIDENCE':
    'CAREMATRIXCPTC.MTEMOTIONS.CONFIDENCE',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.GUILT':
    'CAREMATRIXCPTC.MTEMOTIONS.GUILT',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.DISCOURAGEMENT':
    'CAREMATRIXCPTC.MTEMOTIONS.DISCOURAGEMENT',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.FRUSTRATION':
    'CAREMATRIXCPTC.MTEMOTIONS.FRUSTRATION',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.GRATITUDE':
    'CAREMATRIXCPTC.MTEMOTIONS.GRATITUDE',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.INDIFFERENCE':
    'CAREMATRIXCPTC.MTEMOTIONS.INDIFFERENCE',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.INSECURITY':
    'CAREMATRIXCPTC.MTEMOTIONS.INSECURITY',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.SATISFACTION':
    'CAREMATRIXCPTC.MTEMOTIONS.SATISFACTION',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.PRIDE':
    'CAREMATRIXCPTC.MTEMOTIONS.PRIDE',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.RAGE': 'CAREMATRIXCPTC.MTEMOTIONS.RAGE',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.CALM': 'CAREMATRIXCPTC.MTEMOTIONS.CALM',
  'EXPLORE.MOOD.TRACKER.EMOTIONS.ANSWER.SADNESS':
    'CAREMATRIXCPTC.MTEMOTIONS.SADNESS',
};

export const factorsValues = {
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.FRIENDSHIPS':
    'CAREMATRIXCPTC.MTREASONS.FRIENDSHIPS',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.STUDIES':
    'CAREMATRIXCPTC.MTREASONS.STUDIES',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.MYSELF':
    'CAREMATRIXCPTC.MTREASONS.MYSELF',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.EXERCISES':
    'CAREMATRIXCPTC.MTREASONS.EXERCISES',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.FAMILY':
    'CAREMATRIXCPTC.MTREASONS.FAMILY',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.LEISURE':
    'CAREMATRIXCPTC.MTREASONS.LEISURE',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.RELATIONSHIPS':
    'CAREMATRIXCPTC.MTREASONS.RELATIONSHIPS',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.HEALTH':
    'CAREMATRIXCPTC.MTREASONS.HEALTH',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.SLEEP': 'CAREMATRIXCPTC.MTREASONS.SLEEP',
  'EXPLORE.MOOD.TRACKER.REASONS.ANSWER.WORK': 'CAREMATRIXCPTC.MTREASONS.WORK',
};
